import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const AlertTriangleIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-alert-triangle${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M8 6V8.66667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.90867 2.394L1.50467 11.4167C1.39326 11.6096 1.33431 11.8283 1.33367 12.0511C1.33304 12.2739 1.39073 12.4929 1.50103 12.6865C1.61133 12.88 1.77038 13.0414 1.96236 13.1544C2.15434 13.2674 2.37257 13.3282 2.59533 13.3307H13.4047C13.6273 13.3281 13.8454 13.2673 14.0373 13.1543C14.2292 13.0413 14.3882 12.8801 14.4985 12.6867C14.6088 12.4932 14.6665 12.2743 14.6659 12.0516C14.6654 11.8289 14.6066 11.6102 14.4953 11.4173L9.09133 2.39333C8.97764 2.20567 8.81747 2.05049 8.6263 1.9428C8.43513 1.8351 8.21942 1.77852 8 1.77852C7.78058 1.77852 7.56487 1.8351 7.3737 1.9428C7.18253 2.05049 7.02236 2.20567 6.90867 2.39333"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.6667H8.00667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default AlertTriangleIcon;
